import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as l}from"../../icon-registry.js";const a=l("marshall_islands",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="white" />
            <path
                d="M0 19.988L0 4.5L24 4.5V7.892L0 19.988Z"
                fill="#DD7500" />
            <path
                d="M0 19.732L0 4.5L24 4.5V4.756L0 19.732ZM0 20.244L0 20.5L24 20.5L24 11.028L0 20.244Z"
                fill="#003893" />
            <path
                d="M6.65918 5.38184L6.87962 7.82554L7.64842 6.479L7.30467 7.90132L8.57084 6.73343L7.68631 8.04828L9.36237 7.1385L7.99837 8.25587L9.96997 7.66664L8.21813 8.5103L10.3523 8.28113L8.33248 8.79412L11.998 8.94108L8.33248 9.08804L10.3523 9.60057L8.21813 9.37141L9.96997 10.2155L7.99837 9.62583L9.36237 10.7432L7.68631 9.83388L8.57084 11.1483L7.30467 9.98038L7.64842 11.4032L6.87962 10.0566L6.65918 12.5003L6.43874 10.0566L5.66925 11.4032L6.013 9.98038L4.74752 11.1483L5.63136 9.83388L3.9553 10.7432L5.31999 9.62583L3.3477 10.2155L5.09954 9.37141L2.96606 9.60057L4.98588 9.08804L1.32031 8.94108L4.98588 8.79412L2.96606 8.28113L5.09954 8.5103L3.3477 7.66664L5.31999 8.25587L3.9553 7.1385L5.63136 8.04828L4.74752 6.73343L6.013 7.90132L5.66925 6.479L6.43874 7.82554L6.65918 5.38184Z"
                fill="white" />
        </svg>
    `),d=l("marshall_islands_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_92922)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L24 0.5L24 24.5L0 24.5L0 0.5Z"
                    fill="white" />
                <path
                    d="M0 23.732L0 0.5L24 0.5V5.588L0 23.732Z"
                    fill="#DD7500" />
                <path
                    d="M0 23.348L0 0.5L24 0.5V0.884L0 23.348ZM0 24.116L0 24.5L24 24.5L24 10.292L0 24.116Z"
                    fill="#003893" />
                <path
                    d="M7.45606 2.75391L7.6765 6.41947L8.4453 4.39966L8.10154 6.53314L9.36771 4.7813L8.48318 6.75358L10.1592 5.3889L8.79525 7.06496L10.7668 6.18111L9.015 7.4466L11.1492 7.10284L9.12936 7.87233L12.7949 8.09277L9.12936 8.31322L11.1492 9.08201L9.015 8.73826L10.7668 10.0044L8.79525 9.1199L10.1592 10.796L8.48318 9.43197L9.36771 11.4036L8.10154 9.65172L8.4453 11.7859L7.6765 9.76608L7.45606 13.4316L7.23561 9.76608L6.46613 11.7859L6.80988 9.65172L5.5444 11.4036L6.42824 9.43197L4.75218 10.796L6.11686 9.1199L4.14458 10.0044L5.89642 8.73826L3.76294 9.08201L5.78275 8.31322L2.11719 8.09277L5.78275 7.87233L3.76294 7.10284L5.89642 7.4466L4.14458 6.18111L6.11686 7.06496L4.75218 5.3889L6.42824 6.75358L5.5444 4.7813L6.80988 6.53314L6.46613 4.39966L7.23561 6.41947L7.45606 2.75391Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19477_92922">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{a as MarshallIslands,d as MarshallIslandsRounded};
